// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ATf6quo7{aspect-ratio:16/9;width:100%}.Xaol7nu\\+,.ATf6quo7{border-radius:inherit}@supports not (aspect-ratio:16/9){.Xaol7nu\\+{padding-top:56.25%;position:relative;width:100%}.ATf6quo7{height:100%;left:0;position:absolute;top:0;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframe": "ATf6quo7",
	"container": "Xaol7nu+"
};
module.exports = ___CSS_LOADER_EXPORT___;
